import * as actions from './counts.actions';
import reducer from './counts.reducer';
import middleware from './counts.middleware'

export { actions, reducer, middleware }
export default { actions, reducer }


// WEBPACK FOOTER //
// ./src/modules/counts/counts.module.js